import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch } from "./helpers"

import "./styles/index.css"

unbindOriginalSearch('form.relative');

document.querySelector('header').classList.add('nosto-header')

if (
    window.pageYOffset < 15
) {
    document.body.classList.add('ns-scrolled-top')
}

const handleScroll = () => {
    if (
        window.pageYOffset < 15
    ) {
        document.body.classList.add('ns-scrolled-top')
    } else {
        document.body.classList.remove('ns-scrolled-top')
    }
};

window.addEventListener('scroll', handleScroll);

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "input#search-input",
    contentCssSelector: "main#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: window.location.href.includes("/collections/customizer") ? '/' : '',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "tags1",
                'customFields.key',
                'customFields.value',
                'alternateImageUrls', 
                'skus.id',
                'skus.availability',
                'skus.customFields.key', 
                'skus.customFields.value',
                'skus.imageUrl',
                "skus.price",
                "skus.listPrice"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0,
            filter: !window.location.href.includes('/collections/customizer') && [{ field: "tags1", value: ["is_gan_product::False"] }]
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "tags1",
                'customFields.key',
                'customFields.value',
                'alternateImageUrls',
                'skus.id',
                'skus.customFields.key', 
                'skus.customFields.value',
                'skus.imageUrl',
                "skus.price",
                "skus.listPrice"
            ],
            size: defaultConfig.autocompleteProductsSize,
            filter: [{ field: "tags1", value: ["is_gan_product::False"] }]  
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '.product-grid-section',
    isCategoryPage: () => location.pathname.startsWith('/collections'),
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                // categoryPath: document.querySelector('title')?.textContent,
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
})
